import { getLocale, useIntl } from 'umi';
import { NO_DATE } from '../../constants';
import BubbleCommon from '@op/components/BubbleCommon';
import React, { useCallback, useMemo } from 'react';
import { DBO_V } from '@op/utils/format';
import { LocaleType } from '@op/types/common';
/**
 * TODO: 其他系统使用
 * 转换选项名称的中英文
 * @param props
 * @returns
 */
export default function useLanguage(props?: {
  showIcon?: boolean;
  placement?: 'left' | 'right' | 'top' | 'bottom' | 'auto';
}) {
  const { showIcon = false, placement = 'auto' } = props || {};

  const { formatMessage } = useIntl();
  const formatOptionsMessage = useCallback(
    (
      options: Array<{ [key: string]: any; text: string }>,
      renderItem?: (item: any, realText: any) => any,
      bubbleOptions?: {
        showIcon?: boolean;
        placement?: 'left' | 'right' | 'top' | 'bottom' | 'auto';
        style?: React.CSSProperties;
      },
    ): Array<{ [key: string]: any; text: string; value: string }> => {
      return options.map((item) => {
        if (item.text) {
          let realText: any = formatMessage({ id: item.text || NO_DATE.EMPTY });
          const oldText = realText;
          if (item.tips) {
            realText = (
              <BubbleCommon
                tipsMap={item.tips}
                showIcon={bubbleOptions?.showIcon ?? showIcon}
                placement={bubbleOptions?.placement ?? placement}
                style={bubbleOptions?.style || {}}
              >
                <span className="title-text">{realText}</span>
              </BubbleCommon>
            );
          }
          return {
            ...item,
            text: renderItem ? renderItem(item, realText) : realText,
            oldText,
          };
        }
        return item as any;
      });
    },
    [formatMessage],
  );
  const intl = (value: string) => formatMessage({ id: value });

  const localFormatMessage = useCallback(
    (data: string | { id: string }, ...args: any) => {
      const value = typeof data === 'object' ? data?.id : data;

      if (DBO_V.is_empty(value)) return '';

      if (typeof value !== 'string') return value; 

      return formatMessage({ id: value }, ...args);
    },
    [formatMessage],
  );

  const { selected, isEn } = useMemo(() => {
    const local: LocaleType = getLocale();

    return {
      selected: local,
      isEn: local === 'en-US',
    };
  }, [formatMessage]);

  return {
    formatOptionsMessage,
    formatMessage: localFormatMessage,
    intl,
    selected,
    isEn,
  };
}
